import { render, staticRenderFns } from "./additional-information-section.vue?vue&type=template&id=32b70b67"
import script from "./additional-information-section.vue?vue&type=script&lang=ts"
export * from "./additional-information-section.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports